// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "element-ui/packages/theme-chalk/lib/index.css"
import Vue from 'vue'
import App from './App'
import "./assets/iconfont/iconfont.css"
import store from "./store"


/* 路由 */
import router from './router'

/* swiper */
import 'swiper/dist/css/swiper.min.css'


/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* 重置样式 */
import "./assets/css/common.scss"
import './assets/css/reset.min.css'
import "./assets/css/media.scss"

/* 富文本编辑器 */
import "quill/dist/quill.bubble.css"
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"

/* animate.css */
import 'animate.css'

import { Button, Col, Collapse, CollapseItem, Form, FormItem, Input, Loading, Row } from 'element-ui'
Vue.use(Loading)
  .use(Collapse)
  .use(CollapseItem)
  .use(Row)
  .use(Col)
  .use(Button)
  .use(Input)
  .use(Form)
  .use(FormItem)
//无数据组件
import Empty from "./components/Empty.vue"
Vue.component(Empty.name, Empty)

/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name, Header)

/* 页码组件 */
import Paging from './components/Paging.vue'
Vue.component(Paging.name, Paging)


/* 尾部组件 */
import Footer from './components/FooterNew.vue'
Vue.component(Footer.name, Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name, GoTop)

/* 翻译组建 */
import Transfer from './components/Transfer.vue'
Vue.component(Transfer.name, Transfer)

Vue.config.productionTip = false

// 过滤器
import * as custom from './utils/utils'
Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key])
})


router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
  window.scrollTo(0, 0)
  document.querySelector("body").setAttribute("style", "overflow: auto !important;")
})
router.afterEach(() => {
  window.scrollTo(0, 0)
  document.querySelector("body").setAttribute("style", "overflow: auto !important;")
})


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js